import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from '@mui/material';

export default function Step2PersonalInfo({ data }) {
  if (!data) return null;

  const staffList = Object.values(data);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>2. Personal Info Preview</Typography>
      <Typography variant="body2" color="textSecondary" mb={3}>
        Review the unified personal profiles generated from your uploaded data.
      </Typography>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
              <TableCell><strong>Staff Code</strong></TableCell>
              <TableCell><strong>Payroll ID</strong></TableCell>
              <TableCell><strong>Full Name</strong></TableCell>
              <TableCell><strong>NRC Number</strong></TableCell>
              <TableCell><strong>Gender</strong></TableCell>
              <TableCell><strong>Auto Password</strong></TableCell>
              <TableCell><strong>Timeline Events</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {staffList.map(staff => (
              <TableRow key={staff.staff_code}>
                <TableCell>{staff.staff_code}</TableCell>
                <TableCell>{staff.employee_number || '-'}</TableCell>
                <TableCell>{staff.full_name}</TableCell>
                <TableCell>{staff.nrc_number}</TableCell>
                <TableCell>{staff.gender || 'Unknown'}</TableCell>
                <TableCell>
                  <Chip label={staff.password} size="small" variant="outlined" color="primary" />
                </TableCell>
                <TableCell>
                  <Chip label={`${(staff.events || []).length} events`} size="small" color="secondary" />
                </TableCell>
              </TableRow>
            ))}
            {staffList.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">No staff found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
